<ng-template [ngIf]="users.loaded && users.pagination.total === 0">
  <app-no-content-stub
    [icon]="'people'"
    [text]="mode === 'students' ? 'no-content-stub.users.students'
    : (mode === 'subscriptions' ? (isTeacher ? 'no-content-stub.users.subscriptions' : 'no-content-stub.users.subscriptions-student')
    : (mode === 'subscribers' ? (isTeacher ? 'no-content-stub.users.subscribers' : 'no-content-stub.users.subscribers-student') : ''))">
  </app-no-content-stub>
</ng-template>

<div class="list" *ngIf="users.loaded" [class.mobile]="deviceService.isMobile()">
  <app-user-card-mini *ngFor="let user of users.items; trackBy: trackByFn" [user]="user"></app-user-card-mini>
</div>

<app-pagination
  [enabled]="users.loaded"
  [loading]="users.loading"
  [pagination]="users.pagination"
  baseUrl=""
  (nextPage)="nextPage()"></app-pagination>
